/**
 * KYC Completion List Component
 * Displays steps for completing KYC and IBAN submission with bank partners
 */

import { DescriptionList } from '@bitcoin-com/react-components/src/components/description-list'
import type { DescriptionListItem } from '@bitcoin-com/react-components/src/components/description-list/DescriptionList.types'
import { Button } from '../../components/common/Button'
import { CheckCircleIcon } from '../../assets/icons'

export interface KYCStep {
  id: string
  label: string
  status: 'pending' | 'in_progress' | 'completed'
  description: string
  actionUrl?: string
  actionLabel?: string
}

interface KYCCompletionListProps {
  steps: KYCStep[]
  bankName: string
}

export function KYCCompletionList({ steps, bankName }: KYCCompletionListProps) {
  const items: DescriptionListItem[] = steps.map((step) => ({
    id: step.id,
    label: step.label,
    value: (
      <div className="flex flex-col gap-xs w-full">
        <div className="flex items-center gap-xs">
          {step.status === 'completed' && (
            <CheckCircleIcon className="w-4 h-4 text-green-500" />
          )}
          <span className="font-['Satoshi_Variable'] font-medium text-[14px] text-shades-dark">
            {step.description}
          </span>
        </div>
        {step.status !== 'completed' && step.actionUrl && step.actionLabel && (
          <div className="mt-xs">
            <Button
              variant="primary"
              size="sm"
              onClick={() => window.open(step.actionUrl, '_blank', 'noopener,noreferrer')}
            >
              {step.actionLabel}
            </Button>
          </div>
        )}
      </div>
    ),
    isNumeric: false
  }))

  return (
    <div className="space-y-m">
      <div className="space-y-xs">
        <h3 className="font-display font-black text-heading-md uppercase text-text-primary">
          Complete Your Application
        </h3>
        <p className="font-['Satoshi_Variable'] font-medium text-[14px] text-shades-dark">
          Finish these steps with {bankName} to receive your loan funds
        </p>
      </div>
      <DescriptionList items={items} variant="responsive" />
    </div>
  )
}

